import styled from "styled-components";

export const InputWithText = styled.div`
    display: flex;
    align-items: top;

    > div {
        &:first-child {
            margin-right: 10px;
            margin-top: 12px;
        }

        &:nth-child(2) {
            width: 100%;
        }
    }
`;